import React, { useState } from 'react'
import firebase from 'firebase/app'
import { useDispatch } from "react-redux"
import withAuthorization from 'components/hoc/withAuthorization'
const Profile = () => {
    

    return (
        

       
         <img src="https://3.bp.blogspot.com/_iEDQIFel3Dw/TLKUyzUuNfI/AAAAAAAAAAk/5_n-dPgqGHw/s1600/groovesharkwebsitedown.png" alt="404page" />
        )
    }
    export default withAuthorization(Profile)
